export const environment = {
  production: true,
  endpoint: 'https://siparisentegrasyon.com/api',
  fileEndpoint: 'https://siparisentegrasyon.com/api/file/'
};
